import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" className="min-h-[60vh] flex items-center justify-center p-6">
          <div className="max-w-md w-full rounded-2xl border border-black/10 bg-white p-8 text-center">
            <div className="w-14 h-14 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4">
              <AlertTriangle className="w-7 h-7" />
            </div>
            <h2 className="text-lg font-extrabold text-[#0A1C30]">Ocurrió un problema al cargar esta sección</h2>
            <p className="text-sm text-[#6B7688] mt-2">
              No pudimos mostrar el contenido. Intenta recargar la página. Si el problema continúa, avísanos.
            </p>
            <div className="flex gap-2 justify-center mt-5">
              <button
                data-testid="error-reload"
                onClick={() => window.location.reload()}
                className="flex items-center gap-2 text-sm font-bold px-4 py-2 rounded-xl bg-[var(--gold)] text-[#0A1C30]"
              >
                <RefreshCw className="w-4 h-4" /> Recargar
              </button>
              <button
                onClick={this.handleReset}
                className="text-sm font-bold px-4 py-2 rounded-xl bg-black/5 text-[#0A1C30]"
              >
                Reintentar
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
